import { requireData, toAppError } from "../../lib/appError";
import type { Database } from "../../lib/database.types";
import { supabase } from "../../lib/supabaseClient";

export type Subscription = Database["public"]["Tables"]["subscriptions"]["Row"];

export const billingRepository = {
  async getUser(): Promise<{ id: string; email?: string }> {
    const { data, error } = await supabase.auth.getUser();
    const user = requireData(data.user, error, "You must be signed in.");
    return { id: user.id, email: user.email };
  },

  async getSubscription(): Promise<Subscription | null> {
    const user = await billingRepository.getUser();
    const { data, error } = await supabase
      .from("subscriptions")
      .select("*")
      .eq("user_id", user.id)
      .maybeSingle();
    if (error) throw toAppError(error, "Could not load your subscription.");
    return data;
  },

  async hasActiveSubscription(): Promise<boolean> {
    const { data, error } = await supabase.rpc(
      "current_user_has_active_subscription",
    );
    if (error) throw toAppError(error, "Could not check your subscription.");
    return data ?? false;
  },
};
